import { DefaultNextActionType, NextActionType } from '@/api/openapi';

type NextActionTypeOrDefaultType = {
  name: string;
  id: string;
};

/**
 * defaultActionTypeId, actionTypeIdからactionTypeに加工する
 */
const makeNextActionType = (
  defaultActionTypeId: number | null,
  actionTypeId: number | null,
): string =>
  defaultActionTypeId ? makeActionTypeBytDefaultActionTypeId(defaultActionTypeId) : actionTypeId.toString();

const MARGED_DEFAULT_ACTION_TYPE_PREFIX = 'default';
const makeActionTypeBytDefaultActionTypeId = (defaultActionTypeId: number): string => `${MARGED_DEFAULT_ACTION_TYPE_PREFIX}${defaultActionTypeId}`;
const makeActionTypeIdByMergedActiontype = (mergedActiontype: string): string => {
  if (mergedActiontype == null) return null;
  if (mergedActiontype.startsWith(MARGED_DEFAULT_ACTION_TYPE_PREFIX)) return null;
  return mergedActiontype;
};
const makeDefaultActionTypeIdByMergedActiontype = (mergedActiontype: string): string => {
  if (mergedActiontype == null) return null;
  if (!mergedActiontype.startsWith(MARGED_DEFAULT_ACTION_TYPE_PREFIX)) return null;
  return mergedActiontype.replace(MARGED_DEFAULT_ACTION_TYPE_PREFIX, '');
};

const mergeNextActionTypesAndDefaultTypes = (nextActionTypes: NextActionType[], defaultNextActionTypes: DefaultNextActionType[]): NextActionTypeOrDefaultType[] =>
  defaultNextActionTypes
    .map(e => {
      return {
        name: e.name,
        id: makeActionTypeBytDefaultActionTypeId(e.id),
      };
    }).concat(nextActionTypes.map(e => {
      return {
        name: e.name,
        id: `${e.id}`,
      };
    }));

/**
 * nextActionType, defaultNextActionTypeを取り扱うサービス
 */
class NextActionTypesAndDefaultTypes {
  nextActionTypes: NextActionType[];
  defaultNextActionTypes: DefaultNextActionType[];

  constructor(nextActionTypes: NextActionType[], defaultNextActionTypes: DefaultNextActionType[]) {
    this.nextActionTypes = nextActionTypes;
    this.defaultNextActionTypes = defaultNextActionTypes;
  }

  getSelectableNextActionTypesAndDefaultTypes(): NextActionTypeOrDefaultType[] {
    return mergeNextActionTypesAndDefaultTypes(this.nextActionTypes, this.defaultNextActionTypes.filter(e => !e.isNotSelectableByUser));
  }

  getMergedNextActionTypesAndDefaultTypes(): NextActionTypeOrDefaultType[] {
    return this.getSelectableNextActionTypesAndDefaultTypes();
  }
}

export type {
  NextActionTypeOrDefaultType,
};
export {
  makeNextActionType,
  makeActionTypeIdByMergedActiontype,
  makeDefaultActionTypeIdByMergedActiontype,
  NextActionTypesAndDefaultTypes,
};
